var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowLeft = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/arrow-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.586 2.66663H10.4127C5.55935 2.66663 2.66602 5.55996 2.66602 10.4133V21.5733C2.66602 26.44 5.55935 29.3333 10.4127 29.3333H21.5727C26.426 29.3333 29.3193 26.44 29.3193 21.5866V10.4133C29.3327 5.55996 26.4394 2.66663 21.586 2.66663ZM23.9993 17H10.4127L14.426 21.0133C14.8127 21.4 14.8127 22.04 14.426 22.4266C14.226 22.6266 13.9727 22.72 13.7193 22.72C13.466 22.72 13.2127 22.6266 13.0127 22.4266L7.29268 16.7066C7.10602 16.52 6.99935 16.2666 6.99935 16C6.99935 15.7333 7.10602 15.48 7.29268 15.2933L13.0127 9.57329C13.3993 9.18663 14.0393 9.18663 14.426 9.57329C14.8127 9.95996 14.8127 10.6 14.426 10.9866L10.4127 15H23.9993C24.546 15 24.9993 15.4533 24.9993 16C24.9993 16.5466 24.546 17 23.9993 17Z",
    fill: "#527BFF"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-left.8e98dead.svg";
export { ForwardRef as ReactComponent };